export var MetaActions = {
  setValue: 'set-value',
  inputChange: 'input-change',
  inputBlur: 'input-blur',
  menuClose: 'menu-close',
  selectOption: 'select-option',
  deselectOption: 'deselect-option',
  removeValue: 'remove-value',
  popValue: 'pop-value',
  clear: 'clear',
  createOption: 'create-option',
  clearOptions: 'clear-options',
  add: 'add',
  remove: 'remove',
  update: 'update'
};